import { useContext } from "react";
import { OTPInput, OTPInputContext, REGEXP_ONLY_DIGITS } from "input-otp";

const Slot = ({ index }) => {
  const { char, isActive } = useContext(OTPInputContext).slots[index];
  return (
    <div className={`h-14 w-12 rounded-xl border-2 flex items-center justify-center text-2xl font-bold bg-white transition-colors ${isActive ? "border-red-600" : char ? "border-blue-800" : "border-slate-200"}`}>
      {char ? <span className="h-3 w-3 rounded-full bg-blue-800" /> : null}
    </div>
  );
};

export const PinInput = ({ value, onChange, onComplete, testid, autoFocus = true, disabled }) => (
  <OTPInput
    maxLength={6}
    value={value}
    onChange={onChange}
    onComplete={onComplete}
    pattern={REGEXP_ONLY_DIGITS}
    inputMode="numeric"
    autoFocus={autoFocus}
    disabled={disabled}
    data-testid={testid}
    containerClassName="flex justify-center gap-2"
  >
    {[0, 1, 2, 3, 4, 5].map((i) => <Slot key={i} index={i} />)}
  </OTPInput>
);
